/* src/app/weighbridge/modals/yard-trade-pricing-add-modal/yard-trade-pricing-add-modal.component.scss */
/*# sourceMappingURL=yard-trade-pricing-add-modal.component.css.map */
